import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { Observable } from 'rxjs'
import { ServiceUrlConstants } from '../../constants/service-url-constants'
import { CodeLookup } from 'src/app/models/api.model'

@Injectable({
  providedIn: 'root'
})
export class OptionsService {
  constructor(private webService: WebService) {}

  getOptionsForType(typeArr: string[]): Observable<any> {
    return this.webService.post(ServiceUrlConstants.API_OPTIONS, typeArr)
  }

  saveOption(codeLookup: CodeLookup): Observable<any> {
    return this.webService.post(ServiceUrlConstants.API_OPTION, codeLookup)
  }

  filterCodeLookupsByKey2(codes: CodeLookup[], key2List: string[]): CodeLookup[] {
    return codes?.filter(code => key2List?.includes?.(code.key2))
  }
}
